import React, { useEffect } from 'react';
import './HeroBanner.scss';
import { useNavigate, useLocation } from 'react-router-dom';

const Banner = () => {
    const navigate = useNavigate();
    const location = useLocation();

    // Check if the current URL contains "/agent"
    const isAgentVersion = location.pathname.includes('/agent');

    const navigateToAction = (event) => {
        event.preventDefault();
        if (isAgentVersion) {
            navigate('/agent/valuation'); // Navigate to /agent/valuation
        } else {
            navigate('/property_details'); // Navigate to /property_details
        }
    };

    useEffect(() => {
        const handleScroll = () => {
            const scrollY = window.scrollY;
            const maxScroll = 100;
            const percentage = Math.min(scrollY / maxScroll, 1);
            document.querySelector('.highlight').style.setProperty('--scroll-percentage', percentage);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div className="banner">
            <video autoPlay muted loop className="video-background" preload="auto">
                <source src="https://firebasestorage.googleapis.com/v0/b/content-filter-154e4.appspot.com/o/assets%2FBackground%20Video%20-%20Your%20Move-Estate%20Agent%20-%20Sunderland%20and%20Newcastle%20-%20sm.mp4?alt=media&token=7c032cf6-1032-4f24-9d81-78d488cc45c9" type="video/mp4" />
                Your browser does not support the video tag.
            </video>
            <div className="overlay"></div>
            <div className="content">
                <img src="https://firebasestorage.googleapis.com/v0/b/content-filter-154e4.appspot.com/o/assets%2FChris%20Stonock%20-%20Your%20Move%20-%20Logo.png?alt=media&token=8fe5090a-132e-4e35-8f03-76bb7cf0e0df" alt="Your Move - Chris Stonock" className="logo" />
                <h1>Unlock Your Property's <span className="highlight">Full</span> Value</h1>
                <p>
                    {isAgentVersion
                        ? 'Find out how much your home is worth by getting your FREE property valuation.'
                        : 'Find out how much your home is worth using our FREE online property valuation tool.'}
                </p>
                <div className="hero-buttons">
                    <button onClick={navigateToAction}>
                        {isAgentVersion ? 'Get A Free Property Valuation' : 'Instant Property Valuation'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Banner;
